<template>
  <div style="margin-bottom:56px;" class="hidden-sm-and-up">
    <div class="mobile_nav_wrap hidden-sm-and-up">
      <div class="navbar_left" @click="gobackHome">
        <img src="@/assets/img/home/logo.png" alt="晴天集团" />
      </div>
      <div class="navbar_right">
<!--        <div class="nav_tiyan" @click="gotoExperience">立即体验</div>-->
        <div class="nav_btns" @click="moveMenu">
          <i class="el-icon-menu"></i>
        </div>
      </div>
    </div>
    <Affix>
      <div class="nav_menu" ref="menu">
        <router-link
          class="menu_item"
          to="/home"
          :class="currentActive === 1 ? 'active' : ''"
          >{{$t("nav.home")}}</router-link
        >
        <router-link
          class="menu_item"
          to="/about"
          :class="currentActive === 2 ? 'active' : ''"
          > {{$t("nav.about")}}</router-link
        >
        <div
          class="menu_item"
          @click="changeCenterShow3"
          :class="currentActive === 3 ? 'active' : ''"
        >
          {{$t("nav.portfolioCompanies")}}
        </div>
        <div class="item_options" v-show="centerShow">
          <a href="/portfolio-companies/1" :class="currentActive === 31 ? 'active' : ''" style="height: 25%">{{$t("nav.investOne")}}</a>
          <a href="/portfolio-companies/4" :class="currentActive === 34 ? 'active' : ''" style="height: 25%">{{$t("nav.investFour")}}</a>
          <a href="/portfolio-companies/3" :class="currentActive === 33 ? 'active' : ''" style="height: 25%">{{$t("nav.investThree")}}</a>
          <a href="/portfolio-companies/2" :class="currentActive === 32 ? 'active' : ''" style="height: 25%">{{$t("nav.investTwo")}}</a>
        </div>
        <router-link
            class="menu_item"
            to="/four"
            :class="currentActive === 4 ? 'active' : ''"
        >{{$t("nav.dynamic")}}</router-link>
        <span class="menu_item"
              @click="changeCenterShow5"
            :class="currentActive === 5 ? 'active' : ''"
        > {{$t("nav.proBono")}}</span>
        <router-link
            class="menu_item"
            to="/seven"
            :class="currentActive === 6 ? 'active' : ''"
        > {{$t("nav.contact")}}</router-link>
        <div
            class="menu_item"
            @click="changefireShow"
            :class="currentActive === 7 ? 'active' : ''">
          GLOBAL
        </div>
        <div class="item_options" v-show="fireShow">
          <a style="height: 33.3%" @click="switchLanguage('zh-CN')">简体</a>
          <a style="height: 33.3%" @click="switchLanguage('zh-TW')">繁體</a>
          <a style="height: 33.3%" @click="switchLanguage('en')">English</a>
          <a style="height: 33.3%" @click="switchLanguage('ar')">بالعربية</a>
        </div>
      </div>
    </Affix>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menuShow: false,
      productShow: false,
      centerShow: false,
      fireShow: false,
    }
  },
  props: {
    currentActive: {
      default: 0,
      type: Number,
    },
  },
  methods: {
    changeCenterShow5()
    {
      window.open('http://www.hcccharitablefund.com', '_blank');
    },
    moveMenu() {
      this.menuShow = !this.menuShow
      if (this.menuShow) {
        this.$refs.menu.style.top = '56PX'
      } else {
        this.$refs.menu.style.top = '-1000PX'
      }
    },
    changeCenterShow3() {
      this.centerShow = !this.centerShow
      this.fireShow = false
      this.productShow = false
      this.currentActive = 3;
      // if(window.location.pathname !== "/portfolio-companies/0")
      // {
      //   this.$router.push('/portfolio-companies')
      // }
    },
    changefireShow() {
      this.fireShow = !this.fireShow
      this.centerShow = false
      this.productShow = false
    },
    gobackHome(){
      this.$router.replace('/home').catch(() => {})
    },
    // 切换语言的方法
    switchLanguage(nextLang) {
      // 切换语言
      this.$i18n.locale = nextLang
      // 可以在此处添加保存语言偏好到本地存储的逻辑
      localStorage.setItem('hcc-language', nextLang)
      // this.$router.replace('/home').catch(() => {})
      this.moveMenu()
    },
  },
}
</script>

<style lang="scss" scoped>
.mobile_nav_wrap {
  box-sizing: border-box;
  width: 100%;
  height: 56PX;
  background: #fff;
  z-index: 1000;
  display: flex;
  padding: 15PX 0 15PX 15PX;
  align-items: center;
  position: fixed;
  top: 0;
  .navbar_left {
    flex: 1;
    background: #fff;
    img {
      width: 100%;
    }
  }
  .navbar_right {
    flex: 2;
    height: 56PX;
    display: flex;
    justify-content: flex-end;
    background: #fff;
    .nav_tiyan {
      width: 88PX;
      height: 100%;
      background: #1a63c4;
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14PX;
    }

    .nav_btns {
      width: 56PX;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      i{
        font-size: 30PX;
      }
    }
  }
}
.active{
  color: #F39C00 !important;
  font-weight: bold;
}
.nav_menu{
    position: absolute;
    width: 100%;
    height: 450PX;
    list-style: none;
    left: 0;
    right: 0;
    top: -1000PX;
    padding-bottom: 0;
    box-sizing: border-box;
    background: #EFF0F1;
    box-shadow: 0 10PX 20PX rgba(0,0,0,.1);
    z-index: 999;
    transition: all 0.8s;
    .menu_item{
      width: 100%;
      height: 40PX;
      font-size: 16PX;
      background: #EFF0F1;
      color: #1c212d;
      padding: 30PX;
      display: flex;
      align-items: center;
    }
    .item_options{
      width: 100%;
      padding: 5PX 10PX;
      font-size: 14PX;
      background: #fff;
      a{
        display: inline-block;
        width: 100%;
        color: #666;
        height: 25%;
        padding: 20px 30PX;
      }
    }
  }
</style>
